import {gql} from "@apollo/client";

export const GetChatGroupIdQuery = gql`
    query getChatGroupByIdQuery($chatGroupId: String!) {
        chatGroupById(chatGroupId: $chatGroupId) {
            id
            opponent {
                id
                firstName
                inboxInfoOne
                countryCode
                inboxInfoTwo
                isEnterprise
                headlineInfo
                profilePhoto
                accountRole
                isOnline
                degreeLevel
                degrees {
                    degreeType
                    degree {
                        id
                        name
                    }
                }
            }
            creationSource {
                id
                slug
                type
                name
            }
        }
    }
`;
